// extracted by mini-css-extract-plugin
export default {"download_pdf_button_wrapper":"rXLbw2BEWbyEj39gAwqx","download_pdf_button_icon":"LE0UoflvHg8hLKj9KNyS"};